import React from 'react';
import { HeroProps } from '@/components/hero/types';
import { heroVariantMap } from './const';

const Hero: React.FC<HeroProps> = (props) => {
  const HeroComponent = heroVariantMap[props.variant];

  return HeroComponent ? <HeroComponent {...props} /> : null;
};

export default Hero;
